/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Col_LinkInputs */

const en_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const de_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const fr_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const es_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const it_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const nl_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const pl_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const fi_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const da_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const sv_portal_scanner_col_link = /** @type {(inputs: Portal_Scanner_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Portal_Scanner_Col_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_col_link = /** @type {((inputs?: Portal_Scanner_Col_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Col_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_col_link(inputs)
	if (locale === "fr") return fr_portal_scanner_col_link(inputs)
	if (locale === "es") return es_portal_scanner_col_link(inputs)
	if (locale === "it") return it_portal_scanner_col_link(inputs)
	if (locale === "nl") return nl_portal_scanner_col_link(inputs)
	if (locale === "pl") return pl_portal_scanner_col_link(inputs)
	if (locale === "fi") return fi_portal_scanner_col_link(inputs)
	if (locale === "da") return da_portal_scanner_col_link(inputs)
	if (locale === "sv") return sv_portal_scanner_col_link(inputs)
	return en_portal_scanner_col_link(inputs)
});